import { RiExternalLinkLine, RiInformation2Line } from "react-icons/ri";

import { IconButton } from "@/components/atoms/IconButton";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/molecules/Popover";

// 注意事項 PDF の配布先。用意されるまでは案内自体を出さない
const connectPrecautionsLinkUrl = import.meta.env.VITE_PRECAUTIONS_PDF_URL;

export const ConnectPrecautions = () => {
  if (!connectPrecautionsLinkUrl) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton
          variant="noBgPrimary"
          size="small"
          ariaLabel="ご利用に関するご案内一覧"
        >
          <RiInformation2Line size={20} />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        sideOffset={8}
        className="w-auto rounded-sm border border-gray-100 bg-white p-0 shadow-lg will-change-[transform,opacity] data-[state=open]:data-[side=bottom]:animate-slide-down-and-fade data-[state=open]:data-[side=left]:animate-slide-right-and-fade data-[state=open]:data-[side=right]:animate-slide-left-and-fade data-[state=open]:data-[side=top]:animate-slide-up-and-fade"
      >
        <a
          href={connectPrecautionsLinkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full items-center gap-1 p-4 text-left text-Medium hover:bg-primary-50 hover:underline"
        >
          ご利用に関する注意事項
          <RiExternalLinkLine size={16} className="text-gray-600" />
        </a>
      </PopoverContent>
    </Popover>
  );
};
